// Today's palette as space-separated RGB channels. A site theme overrides these at runtime.
export const DEFAULT_THEME_CHANNELS = {
  "surface-page": "250 250 250",
  "surface-card": "255 255 255",
  "surface-card-secondary": "247 247 247",
  "surface-hover": "243 244 246",
  divider: "236 236 236",
  border: "233 233 235",
  ink: "0 0 0",
  "ink-secondary": "107 114 128",
  "ink-tertiary": "31 41 55",
  "ink-disabled": "156 163 175",
  primary: "0 0 0",
  "primary-hover": "40 40 40",
  "primary-soft-base": "0 0 0",
  "on-primary": "255 255 255",
  accent: "146 87 15",
  "accent-soft": "254 238 199",
  "accent-soft-hover": "254 229 176",
  "on-accent": "255 255 255",
  success: "3 99 70",
  error: "185 28 28",
  warning: "146 64 14",
  "warning-soft": "254 243 199",
  "on-status": "255 255 255",
  "toast-success": "3 99 70",
  "on-toast-success": "255 255 255",
};

export type ThemeToken = keyof typeof DEFAULT_THEME_CHANNELS;

export const DEFAULT_SCRIM_ALPHA = "0.5";

/** Multiplies every corner radius; a site that turns rounded corners off sets it to 0. */
export const DEFAULT_RADIUS_SCALE = "1";
/** A radius that squares off along with the rest of the WBE, for styles Tailwind doesn't reach. */
export const scaledRadius = (value: string) =>
  `calc(${value} * var(--wbe-radius-scale, ${DEFAULT_RADIUS_SCALE}))`;
/** Badges stay pills while corners are rounded… */
export const DEFAULT_BADGE_RADIUS = "9999px";
/** …and keep this slight rounding once they are not, so they still read as badges. */
export const SQUARE_BADGE_RADIUS = "3px";
